module.exports = __webpack_public_path__ + "img/零食2.2f6459c5.png";